import React, { useState } from "react";
import toast from "react-hot-toast";
import { Document, Page } from "react-pdf";
import { pdfjs } from "react-pdf";
import { Dialog, DialogTitle, IconButton, Pagination } from "@mui/material";
import printJS from "print-js";

import Close from "assets/images/close-black.svg";
import DownloadIcon from "assets/images/download-green.svg";
import PrintIcon from "assets/images/printer-green.svg";
import { Loader } from "components/Loader/Loader";
import { Button } from "components/ui/Button";
import { usePatientLabel } from "features/patients/hooks/usePatientLabel";

import s from "./PDFDisplayModal.module.css";

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const PDFDisplayModal = ({ open, onClose }) => {
  const { data: pdfData } = usePatientLabel();

  const [numPages, setNumPages] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  const printPdf = () => {
    try {
      const url = URL.createObjectURL(pdfData);
      printJS({
        printable: url,
        type: "pdf",
        showModal: false,
      });
    } catch (error) {
      toast.error("Error printing PDF: " + error.message);
    }
  };

  const downloadPDF = () => {
    try {
      const url = window.URL.createObjectURL(pdfData);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "patient-label.pdf");
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      toast.error("Error downloading PDF: " + error.message);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{ sx: { borderRadius: "12px" } }}
    >
      <DialogTitle>Label preview</DialogTitle>
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={(theme) => ({
          position: "absolute",
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <img src={Close} alt="close icon" />
      </IconButton>
      <div className={s.modalContent}>
        <div className={s.pdfContainer}>
          {pdfData ? (
            <Document file={pdfData} onLoadSuccess={onDocumentLoadSuccess}>
              <Page
                pageNumber={pageNumber}
                height={200}
                renderTextLayer={false}
                renderAnnotationLayer={false}
              />
            </Document>
          ) : (
            <Loader />
          )}
        </div>

        {numPages > 1 && (
          <Pagination
            count={numPages}
            page={pageNumber}
            onChange={(event, value) => setPageNumber(value)}
            color="primary"
          />
        )}

        <div className={s.buttonContainer}>
          <Button variant="primary" onClick={downloadPDF} className={s.button}>
            <img src={DownloadIcon} alt="" />
            Download PDF
          </Button>

          <Button variant="primary" onClick={printPdf} className={s.button}>
            <img src={PrintIcon} alt="" />
            Print PDF
          </Button>
        </div>
      </div>
    </Dialog>
  );
};

export { PDFDisplayModal };
